import React, { useState, useEffect } from 'react';
import Select from 'react-select'
import { Link } from 'react-router-dom';
import { fetchCollection, addTournamentToDb, addAssociationToDb } from './utils';
import DatePicker from 'react-date-picker'
import 'react-date-picker/dist/DatePicker.css';
import Switch from "react-switch";
import { auth } from '../../firebase';

function CreateAssociation() {

    // Page status
    const [loading, setLoading] = useState(true)

    // user information
    const [userId, setUserId] = useState("")

    // Data fetched from DB
    const [associations, setAssociations] = useState([])
    const [associationTypes, setAssociationTypes] = useState([])

    // Form values
    const [newAssociationName, setNewAssociationName] = useState("")
    const [newAssociationType, setNewAssociationType] = useState([])

    
    const createAssociation = async () => {
        setLoading(true)

        // Fetch user information from firebase auth
        const currentUser = auth.currentUser ? auth.currentUser.uid : ""
        setUserId(currentUser)
        
        // confirm that there is not an existing association with the same name
        if (associations.includes(newAssociationName)) {
            alert("Association already exists")
            setLoading(false)
            return
        }

        const docRef = await addAssociationToDb({
            name: newAssociationName,
            associationType: newAssociationType.value,
            createdBy: userId,
            createdAt: new Date().toISOString()
        })
        console.log("association document written with ID: ", docRef.id);
        resetForm()
        setLoading(false)
    }

    const resetForm = () => {
        setNewAssociationName("")
        setNewAssociationType([])
    }

    const fetchData = async () => {
        setLoading(true)
        


        const associationsListLocal = []
        const associationDocs = await fetchCollection("associations")
        associationDocs.forEach((doc) => {
            // doc.data() is never undefined for query doc snapshots
            const docData = doc.data()
            associationsListLocal.push(docData.name)
        });
        setAssociations(associationsListLocal)

        const associationTypesListLocal = []
        const associationTypeDocs = await fetchCollection("associationTypes")
        associationTypeDocs.forEach((doc) => {
            // doc.data() is never undefined for query doc snapshots
            const docData = doc.data()
            const associationObject = {
                label: docData.type,
                value: docData.type,
                id: doc.id
            }
            associationTypesListLocal.push(associationObject)
        })
        setAssociationTypes(associationTypesListLocal)
        setLoading(false)
    }

    useEffect(() => {
        fetchData()
    }, []);

    if (loading) {
        return (
            <div className="admin-login-bg">
                <div className="admin-login-card">
                    <div className="admin-login-loading">
                        <div className="admin-login-spinner"></div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="admin-login-bg">
            <div className="admin-login-card" style={{ maxWidth: 500 }}>
                <h1 className="admin-login-title">Create Association</h1>
                <form className="admin-login-form" style={{ gap: "1.2rem" }}>
                    <div>
                        <label className="admin-login-label">Association Name</label>
                        <input
                            className="admin-login-input"
                            value={newAssociationName}
                            onChange={e => setNewAssociationName(e.target.value)}
                            placeholder="Enter association name"
                        />
                    </div>
                    <div>
                        <label className="admin-login-label">Association Type</label>
                        <Select
                            isDisabled={false}
                            isMulti={false}
                            menuPlacement='auto'
                            menuPosition='fixed'
                            options={associationTypes}
                            onChange={setNewAssociationType}
                            placeholder="Select association type"
                        />
                    </div>
                    <div style={{ marginTop: "1.5rem" }}>
                        <button
                            className="admin-login-btn"
                            type="button"
                            onClick={createAssociation}
                        >
                            Create Association
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default CreateAssociation;